import { render } from "./Contact.vue?vue&type=template&id=61907ebf&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=61907ebf&scoped=true&lang=css"

import exportComponent from "/Users/a.lawson/VUE_JS/sp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61907ebf"]])

export default __exports__